import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import { useGlobalEvent } from 'beautiful-react-hooks';

const openRollUpLimitLearnMoreModalEventName =
  'roll-up-limit-learn-more-modal::open';
const closeRollUpLimitLearnMoreModalEventName =
  'roll-up-limit-learn-more-modal::close';

export const openRollUpLimitAddOnLearnMoreModal = () =>
  window.dispatchEvent(new CustomEvent(openRollUpLimitLearnMoreModalEventName));

export const closeRollUpLimitAddOnLearnMoreModal = () =>
  window.dispatchEvent(
    new CustomEvent(closeRollUpLimitLearnMoreModalEventName)
  );

export interface RollUpLimitAddOnLearnMoreModalProps {
  onCtaClick?: () => void;
  ctaVariant?: ButtonVariant;
  ctaText?: string;
  monthlyPrice?: number;
}

export const RollUpLimitAddOnLearnMoreModal = ({
  onCtaClick,
  ctaVariant = ButtonVariant.Primary,
  ctaText = 'Get Growth lite add-on',
  monthlyPrice,
}: RollUpLimitAddOnLearnMoreModalProps) => {
  const [open, setOpen] = useState(false);

  const onOpenRollUpLimitAddOnLearnMoreModal = useGlobalEvent(
    openRollUpLimitLearnMoreModalEventName as keyof WindowEventMap
  );
  const onCloseRollUpLimitAddOnLearnMoreModal = useGlobalEvent(
    closeRollUpLimitLearnMoreModalEventName as keyof WindowEventMap
  );

  onOpenRollUpLimitAddOnLearnMoreModal(() => setOpen(true));
  onCloseRollUpLimitAddOnLearnMoreModal(() => setOpen(false));

  const closeModal = () => setOpen(false);

  const modalProps = useMemo<ModalProps>(() => {
    return {
      open,
      onModalClose: closeModal,
      closeButtonClassName: '!w-5',
      className: '!w-[820px] !inset-px !p-7',
    };
  }, [open]);

  const cardProps = [
    {
      title: 'Roll-ups',
      description:
        'Roll-up combines multiple tasks on your list to send 1 message to multiple contacts (up to 250 contacts)',
      imageUrl: 'https://cdn.bonjoro.com/assets/images/roll-up-bear.png',
      imageClassName: 'w-[195px]',
    },
    {
      title: 'Remove Bonjoro Badge',
      description:
        'Remove the “Powered by Bonjoro” badge from your video landing pages and white label your videos',
      imageUrl: 'https://cdn.bonjoro.com/assets/images/loveletter-bear.png',
      imageClassName: 'w-[178px]',
    },
  ];

  return (
    <Modal {...modalProps}>
      <div className='flex flex-col gap-y-5 items-center'>
        <span className='text-[28px] font-bold'>Growth lite add-on</span>
        <span className='text-base'>
          Get Roll-ups and remove Bonjoro badge from your video landing pages
          for ${monthlyPrice} USD per month
        </span>
        <div className='flex flex-col min-[440px]:flex-row gap-5'>
          {cardProps?.map((card, index) => (
            <div
              key={index}
              className={cx([
                'flex flex-col gap-y-2 w-full pt-[30px] pb-0 rounded-md',
                'border border-solid v2-border-neutral-300',
              ])}
            >
              <div className='flex flex-col gap-y-5 px-[30px]'>
                <div className='flex flex-row gap-x-5 items-center'>
                  <i className='icon icon-tick !v2-bg-yellow-600 !w-[30px] !h-[24px]' />
                  <span className='text-[21px] font-bold'>{card.title}</span>
                </div>
                <span className='text-base'>{card.description}</span>
              </div>
              <img
                className={cx(
                  card.imageClassName,
                  'items-right h-[150px] w-fit self-end bottom-0 right-0'
                )}
                src={card.imageUrl}
              />
            </div>
          ))}
        </div>
        <Button variant={ctaVariant} onClick={onCtaClick} className='py-1.5'>
          {ctaText}
        </Button>
      </div>
    </Modal>
  );
};
